/* eslint-disable max-lines-per-function */
import { AuxCard, AuxSelect, AuxTabBar } from "@blk/aladdin-react-components-es";
import { camelCase } from "lodash";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "./insExportDataAdministration.scss";
import { uuid } from "short-uuid";
import { InsAssetsDataExportGrid } from "./assets/insAssetsDataExportGrid";
import { InsFundsDataExportGrid } from "./funds/insFundsDataExportGrid";
import { InsHistoryDataExportGrid } from "./history/insHistoryDataExportGrid";
import { InsExportDataAdministrationAction } from "./insExportDataAdministrationAction";
import { InsInvestorsAccountsDataExportGrid } from "./investors/insInvestorsAccountsDataExportGrid";
import { InsManagersDataExportGrid } from "./managers/insManagersDataExportGrid";
import { InsPortfoliosDataExportGrid } from "./portfolios/insPortfoliosDataExportGrid";
import InsSubmissionsDatExportGrid from "./submissions/insSubmissionsDataExportGrid";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { clearSelectedRows } from "store/grids";
import { getCurrentLocalTime } from "common/date-utils";
const mLanguage = language.en.administration.dataAdministration;
export var DataExportTypes;
(function (DataExportTypes) {
    DataExportTypes["Portfolio"] = "Portfolio";
    DataExportTypes["InvestorAccounts"] = "InvestorAccounts";
    DataExportTypes["Funds"] = "Funds";
    DataExportTypes["Managers"] = "Managers";
    DataExportTypes["Assets"] = "Assets";
    DataExportTypes["Submissions"] = "Submissions";
})(DataExportTypes || (DataExportTypes = {}));
export var DataExportGridTypes;
(function (DataExportGridTypes) {
    DataExportGridTypes["Portfolio"] = "portfolios-data-export-grid";
    DataExportGridTypes["InvestorAccounts"] = "investorAccounts-data-export-grid";
    DataExportGridTypes["Funds"] = "funds-data-export-grid";
    DataExportGridTypes["Managers"] = "managers-data-export-grid";
    DataExportGridTypes["Assets"] = "assets-data-export-grid";
    DataExportGridTypes["Submissions"] = "submissions-data-export-grid";
})(DataExportGridTypes || (DataExportGridTypes = {}));
export const InsExportDataAdministration = (props) => {
    const [selectedEntity, setSelectedEntity] = useState(props.selected ?? DataExportTypes.Portfolio);
    const [selectedTabUid, setSelctedTabUid] = useState("0");
    const [selectedExportGrid, setSelectedExportGrid] = useState(DataExportGridTypes.Portfolio);
    const dispatch = useDispatch();
    const entities = Object.values(DataExportTypes), labels = Object.fromEntries(Object.entries(mLanguage.exportData.exportTypes));
    const entitiesValues = entities.map((entity) => ({
        auxId: uuid(),
        displayValue: labels[camelCase(entity)] ?? "",
        isSelected: selectedEntity === entity,
        value: entities.indexOf(entity)
    }));
    const exportGrids = Object.values(DataExportGridTypes);
    const onTabBarItemSelected = (event) => {
        const { uid } = event.detail.tab;
        if (uid === "1") {
            appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.OpenExportHistory, properties: { LocalTimestamp: getCurrentLocalTime() } });
        }
        setSelctedTabUid(uid);
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "exportDataAdministration_auxTab" },
            React.createElement(AuxTabBar, { tabType: "classic", activeUid: selectedTabUid, data: [
                    { label: mLanguage.exportData.export, uid: "0" },
                    { label: mLanguage.exportData.history, uid: "1" }
                ], onTabBarItemSelected: onTabBarItemSelected })),
        React.createElement(AuxCard, { borderPadding: "12", className: "exportDataAdministration_auxCard" },
            React.createElement("div", { className: "exportDataAdministration_auxCard_content" },
                selectedTabUid === "0" && React.createElement("div", { className: "data-header" },
                    React.createElement(AuxSelect, { size: "small", className: "exportDataAdministration_auxCard_content_dataHeader_auxSelect", data: [
                            {
                                auxId: uuid(),
                                values: entitiesValues
                            }
                        ], isLeftLabel: true, hasInitialOptionPlaceholder: false, onSelectionChanged: (e) => {
                            const selected = e.detail.value;
                            dispatch(clearSelectedRows(exportGrids[selected.value]));
                            setSelectedExportGrid(exportGrids[selected.value]);
                            setSelectedEntity(entities[selected.value]);
                            appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ExportEntitySelection }, { entity: e?.detail?.value?.displayValue });
                        }, label: mLanguage.exportData.selectionLabel }),
                    React.createElement("div", { className: "right" },
                        React.createElement(InsExportDataAdministrationAction, { selectedExportGrid: selectedExportGrid, selectedEntity: selectedEntity }))),
                selectedTabUid === "0" && React.createElement("div", { className: "exportDataAdministration__gridContainer" },
                    selectedEntity === DataExportTypes.Portfolio && React.createElement(InsPortfoliosDataExportGrid, { stateId: DataExportGridTypes.Portfolio }),
                    selectedEntity === DataExportTypes.InvestorAccounts && React.createElement(InsInvestorsAccountsDataExportGrid, { stateId: DataExportGridTypes.InvestorAccounts }),
                    selectedEntity === DataExportTypes.Funds && React.createElement(InsFundsDataExportGrid, { stateId: DataExportGridTypes.Funds }),
                    selectedEntity === DataExportTypes.Managers && React.createElement(InsManagersDataExportGrid, { stateId: DataExportGridTypes.Managers }),
                    selectedEntity === DataExportTypes.Assets && React.createElement(InsAssetsDataExportGrid, { stateId: DataExportGridTypes.Assets }),
                    selectedEntity === DataExportTypes.Submissions && React.createElement(InsSubmissionsDatExportGrid, null)),
                selectedTabUid === "1" && React.createElement("div", { className: "exportDataAdministration__gridContainer" },
                    React.createElement(InsHistoryDataExportGrid, { exportType: selectedEntity })))));
};
